<template>
	<div class="toggle-box">
		<div class="toggle">
			<slot name="toggle">
				<uSwitch @toggle="toggle"></uSwitch>
			</slot>
		</div>
		<div class="content" v-show="contentVisible">
			<slot name="content"></slot>
		</div>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				contentVisible: false
			}
		},
		name: 'toggleBox',
		methods: {
			toggle() {
				this.contentVisible = !this.contentVisible;
				this.$emit('on-toggle');
			}
		}

	}
</script>



// WEBPACK FOOTER //
// src/components/toggleBox/toggleBox.vue